import { useEffect } from 'react';
import { selectAppVersion } from '@/redux/selectors/authSelectors';
import { getAppVersion } from '@/redux/slices/authSlice';
import pkg from '../../../package.json';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';

const useAppVersion = () => {
  const dispatch = useAppDispatch();
  const appVersion = useAppSelector(selectAppVersion);

  useEffect(() => {
    dispatch(getAppVersion());
  }, []);

  useEffect(() => {
    if (!appVersion) return;

    console.log(
      '%c ___  ___  _      _   ___ ___ ___\n' +
        '| _ \\/ _ \\| |    /_\\ | _ \\_ _/ __|\n' +
        `|  _/ (_) | |__ / _ \\|   /| |\\__ \\\n` +
        // if the endpoint has not been updated yet, fallback
        `|_|  \\___/|____/_/ \\_\\_|_\\___|___|  %cv${Array.isArray(appVersion) ? appVersion[0] : appVersion.polaris?.version}\n\n` +
        `%cFE v${pkg.version} | oms_core v${Array.isArray(appVersion) ? appVersion[1] : appVersion.oms_core?.version}`,
      'color: #666',
      'color: #1FEED5',
      'color: #4B4B4B'
    );
  }, [appVersion]);
};

export default useAppVersion;
